<template>
    <div>
        <div class="row">
            <div class="form-group col">
                <label for="lastname">Last Name:</label>
                <input  id="lastname" type="text" class="form-control" placeholder="(partial last name)" 
                    v-model="lastname" v-on:change="handleChange" v-on:keyup.enter="searchClicked">
            </div>
            <div class="form-group col">
                <label for="firstname">First Name:</label>
                <input  id="firstname" type="text" class="form-control" placeholder="(partial first name)" 
                    v-model="firstname" v-on:change="handleChange" v-on:keyup.enter="searchClicked">
            </div>
        </div>
        <div class="row">
            <div class="form-group col">
                <label for="agentnumber">Agent Number:</label>
                <input  id="agentnumber" type="text" class="form-control" placeholder="(agent number)" 
                    v-model="agentnumber" v-on:change="handleChange" v-on:keyup.enter="searchClicked">
            </div>
            <div class="form-group col">
                <label for="companyname">Company Name:</label>
                <input  id="companyname" type="text" class="form-control" placeholder="(partial company name)" 
                    v-model="companyname" v-on:change="handleChange" v-on:keyup.enter="searchClicked">
            </div>
        </div>
        <div class="row">
           <div class="form-group col">
               <button class="btn ml-bk-black ml-white ml-h-orange btnw" v-on:click.prevent="searchClicked">
                  <i class="fas fa-spinner fa-spin ml-orange fa-lg" v-if="searching"></i>
                  <span v-else>
                     <i class="fi-interface-search"></i>
                     SEARCH
                  </span>
               </button>
               &nbsp;
               <button class="btn ml-bk-white ml-corp btnw ml-h-orange clr-btn-border" v-on:click.prevent="clear">
                  <i class="fas fa-spinner fa-spin ml-orange fa-lg" v-if="searching"></i>
                  <span v-else>
                     <i class="fi-interface-cancel"></i>
                     CLEAR
                  </span>
               </button>
            </div>
         </div>
    </div>
</template>

<script>


export default {
    props: ['criteria', 'clear-toggle','searching'],
    data() {
        return {
            firstname: '',
            lastname: '',
            agentnumber: '',
            companyname: ''
        }
    },
    methods: {
        handleChange() {
            let crit = { 
               lastname: this.lastname, 
               firstname: this.firstname,
               agentnumber: this.agentnumber,
               companyname: this.companyname
            }
            this.$emit('crit-change', crit)
        },
        clear() {
            this.firstname = ''
            this.lastname = ''
            this.agentnumber = ''
            this.companyname = ''
            let crit = { 
               lastname: this.lastname, 
               firstname: this.firstname,
               agentnumber: this.agentnumber,
               companyname: this.companyname
            }
            this.$emit('crit-change', crit)
        },
        searchClicked() {
           this.handleChange()
           this.$emit('search-clicked','')
        }
    }
}
</script>

<style scoped lang="scss">
@import '../assets/css/colors.scss';
.btnw {
   width: 120px;
   height: 44px;
}
</style>